import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Footer from '../components/Footer';
import axios from 'axios';
import { auth } from '../firebase'; // Import the initialized auth instance
import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { Helmet } from 'react-helmet';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Select from 'react-select'
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
function Register() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const apiKey = process.env.REACT_APP_API_KEY;
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);
    const toggleConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

    const [user, setUser] = useState({
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        experience: "",
        role: "",
        wholesaler: false, 
        market: [], 
        phone:"",
    });
    const usStates = [
        "Nationwide", "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
        "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
        "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
        "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
        "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
    ];
    const options = usStates.map((state) => ({ value: state, label: state }));
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [selectedMarkets, setSelectedMarkets] = useState([]);

    const handleChange = (selectedOptions) => {
        if (!selectedOptions || selectedOptions.length === 0) {
            setFilteredOptions(options);
            setSelectedMarkets([]);
            setUser(prevUser => ({ ...prevUser, market: [] }));
            return;
        }

        const nationwideSelected = selectedOptions.some(option => option.value === "Nationwide");

        if (nationwideSelected) {
            const nationwideOnly = [{ value: "Nationwide", label: "Nationwide" }];
            setFilteredOptions(nationwideOnly);
            setSelectedMarkets(nationwideOnly);
            setUser(prevUser => ({ ...prevUser, market: ["Nationwide"] }));
        } else {
            setFilteredOptions(options);
            setSelectedMarkets(selectedOptions);
            setUser(prevUser => ({
                ...prevUser,
                market: selectedOptions.map(option => option.value),
            }));
        }
    };


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (currentUser) {
                navigate('/');
            }
        });

        return () => unsubscribe();
    }, [navigate]);
    const onInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: type === "checkbox" ? checked : value,
        }));
    };


    const onSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();

        if (user.password !== user.confirm_password) {
            Swal.fire({
                icon: 'error',
                title: 'Passwords do not match',
                text: 'Please check and try again.',
                customClass: {
                    confirmButton: 'my-confirm-button',
                }
            });
            setLoading(false);
            return;
        }

        try {
            const payload = {
                name: user.username,
                email: user.email,
                password: user.password,
                experience: user.experience,
                role: user.role,
                market: user.market,
                phone: user.phone.startsWith('+') ? user.phone : `+${user.phone}`

            };

            const response = await axios.post("https://api.v1.spotyourleads.com/user/register", payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey,
                }
            });

            if (response.data) {
                Swal.fire({
                    icon: 'success',
                    title: `Registered Successfully`,
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        confirmButton: 'my-confirm-button',
                    }
                });

                try {
                    await signInWithEmailAndPassword(auth, user.email, user.password);
                } catch (signInError) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Sign-in failed',
                        text: signInError.message,
                        customClass: {
                            confirmButton: 'my-confirm-button',
                        }
                    });
                }

                setLoading(false);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Registration failed',
                    text: 'Please try again.',
                    customClass: {
                        confirmButton: 'my-confirm-button',
                    }
                });
                setLoading(false);
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Registration failed',
                text: error.response?.data?.message || error.message,
                customClass: {
                    confirmButton: 'my-confirm-button',
                }
            });
            setLoading(false);
        }
    };
    const handlePhoneChange = (value) => {
        setUser(prev => ({
          ...prev,
          phone: value
        }));
      };
    return (
        <>
            <Helmet>
                <title>Spot Your Leads | Sign Up for Hassle-Free Lead Generation </title>
            </Helmet>
            <section className="homeFourth formSection account signin">
                <Container>
                    <h2>Sign Up \ <Link to="/sign-in">Sign In</Link></h2>

                    <Row>

                        <Col lg={6} md={6} sm={12}>
                            <div className="formDiv">

                                <form method="post"
                                    onSubmit={(e) => onSubmit(e)}
                                >
                                    <div>
                                        <input className="form-control" type='text' name="username"
                                            value={user.username}
                                            onChange={(e) => onInputChange(e)}
                                            placeholder="Username" />
                                    </div>
                                    <div>
                                        <input className="form-control" type='text' name="email"
                                            value={user.email}
                                            onChange={(e) => onInputChange(e)}
                                            placeholder="Email Address" />
                                    </div>
                                    <div>
                                    <PhoneInput
                                    country="us"
                                    value={user.phone}
                                    onChange={handlePhoneChange}
                                    inputClass="form-control"
                                    placeholder="Phone Number"
                                    />
                  </div>
                                    <div className="password-container">
                                        <input
                                            className="form-control"
                                            name="password"
                                            value={user.password}
                                            onChange={onInputChange}
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Password"
                                        />
                                        <span className="eye-icon" onClick={togglePassword}>
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>

                                    <div className="password-container">
                                        <input
                                            className="form-control"
                                            name="confirm_password"
                                            value={user.confirm_password}
                                            onChange={onInputChange}
                                            type={showConfirmPassword ? "text" : "password"}
                                            placeholder="Confirm Password"
                                        />
                                        <span className="eye-icon" onClick={toggleConfirmPassword}>
                                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                    
                                    <div>

                                        <select className="form-control" name="experience" value={user.experience} onChange={onInputChange}>
                                            <option value="" hidden>How long they have you been in the field?</option>
                                            <option value="1~3 years"> 1~3 years</option>
                                            <option value="3~5 years">3~5 years</option>
                                            <option value="5~10 years">5~10 years</option>
                                            <option value="10~15 years">10~15 years</option>
                                            <option value="15~50 years">15~50 years</option>


                                        </select>
                                    </div>

                                    <div>
                                        <select className="form-control" name="role" value={user.role} onChange={onInputChange}>
                                            <option value="" hidden>Please Select Your Role</option>
                                            <option value="wholesaler">Wholesaler</option>
                                            <option value="realtor">Realtor</option>
                                            <option value="investor">Investor</option>
                                            <option value="agent">Agent</option>
                                        </select>
                                    </div>



                                    <div>
                                        <Select
                                            options={filteredOptions}
                                            value={selectedMarkets}
                                            isMulti
                                            onChange={handleChange}
                                            className="basic-multi-select"
                                            classNamePrefix="form-control"
                                            placeholder="Please specify the market you are interested in"
                                        />



                                    </div>

                                    <div>
                                        <button type="submit" disabled={loading}>
                                            {loading ? (
                                                <div className="spinner-overlay">
                                                    <div className="spinner"></div>
                                                </div>
                                            ) : 'Sign Up'}


                                        </button>
                                    </div>
                                    <div className='border mt-2'></div>

                                    <div className='haveAccount'>
                                        <p>have an account?</p><Link to="/sign-in"> Sign In now!</Link>
                                    </div>

                                </form>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12}>

                            <img src="images/signin.svg" alt="account" />

                        </Col>

                    </Row>
                    {/* <div className='note'>
                        <Container>
                            <h5>Special note:</h5>
                            <p>Detailed map\\drawings for the website structure to be easily understood by the designer
                                and the developer Lead types (user friendly) (accurate filters)
                            </p>
                        </Container>
                    </div> */}
                </Container>
            </section>
            <Footer />
            {/* <Helmet>
                <title>spotYourLeads | Register </title>
            </Helmet>
            <section className="homeFourth formSection account">
                <h2>Register an Account</h2>
                <Container fluid>
                    <Row>
                        <Col lg={6} md={6} sm={12}>
                            <div className="formDiv">
                                <form method="post" onSubmit={(e) => onSubmit(e)}>
                                    <div>
                                        <input className="form-control"
                                      />
                                    </div>
                                    <div>
                                        <input className="form-control"
                                            name="last_name"
                                            value={user.last_name}
                                            onChange={(e) => onInputChange(e)}
                                            type='text' placeholder="Last Name" />
                                    </div>
                                    <div>
                                        <input className="form-control" name="username"
                                            value={user.username}
                                            onChange={(e) => onInputChange(e)}
                                            type='text' placeholder="Username" />
                                    </div>
                                    <div>
                                        <input className="form-control" name="email"
                                            value={user.email}
                                            onChange={(e) => onInputChange(e)}
                                            type='email' placeholder="Email" />
                                    </div>
                                    <div>
                                        <PhoneInput
                                        country={"us"}
                                            value={user.phone}
                                            onChange={handlePhoneChange}
                                            inputClass="form-control"
                                            placeholder='phone'
                                            containerStyle={{ marginBottom: '15px' }} // Optional styling
                                        />
                                    </div>
                                    <div>
                                        <input className="form-control" name="password"
                                            value={user.password}
                                            onChange={(e) => onInputChange(e)} type='password' placeholder="Password " />
                                    </div>
                                    <div>
                                        <input className="form-control" name="confirm_password"
                                            value={user.confirm_password}
                                            onChange={(e) => onInputChange(e)} type='password' placeholder="Confirm Password " />
                                    </div>
                                    <div className='checkbox'>
                                        <input name="recive" type='checkbox'  value={user.recive}
                                            onChange={(e) => onInputChange(e)} />
                                        <p>I consent to receive texts, and emails from <span>spotYourLeads</span></p>
                                    </div>
                                    <div>
                                        <button type="submit">Sign Up</button>
                                    </div>
                                    <div className='haveAccount'>
                                        <p>Already have an account?</p><Link to="/SignIn"> Login now!</Link>
                                    </div>
                                </form>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12}>
                            <img src="images/Clippath.png" alt="account" />
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer /> */}
        </>
    )
}

export default Register;
